export const all = [
  "https://img.freepik.com/free-photo/luxurious-car-parked-highway-with-illuminated-headlight-sunset_181624-60607.jpg",
  "https://img.freepik.com/free-photo/luxurious-car-parked-highway-with-illuminated-headlight-sunset_181624-60607.jpg",
  "https://img.freepik.com/free-photo/luxurious-car-parked-highway-with-illuminated-headlight-sunset_181624-60607.jpg",
  // Add more image URLs as needed
];
export const manufacturing = [
  "https://img.freepik.com/free-photo/luxurious-car-parked-highway-with-illuminated-headlight-sunset_181624-60607.jpg",
  "https://img.freepik.com/free-photo/luxurious-car-parked-highway-with-illuminated-headlight-sunset_181624-60607.jpg",
  "https://img.freepik.com/free-photo/luxurious-car-parked-highway-with-illuminated-headlight-sunset_181624-60607.jpg",
  // Add more image URLs as needed
];
export const induction = [
  "https://img.freepik.com/free-photo/luxurious-car-parked-highway-with-illuminated-headlight-sunset_181624-60607.jpg",
  "https://img.freepik.com/free-photo/luxurious-car-parked-highway-with-illuminated-headlight-sunset_181624-60607.jpg",
  "https://img.freepik.com/free-photo/luxurious-car-parked-highway-with-illuminated-headlight-sunset_181624-60607.jpg",
  // Add more image URLs as needed
];
export const leads = [
  "https://img.freepik.com/free-photo/luxurious-car-parked-highway-with-illuminated-headlight-sunset_181624-60607.jpg",
  "https://img.freepik.com/free-photo/luxurious-car-parked-highway-with-illuminated-headlight-sunset_181624-60607.jpg",
  "https://img.freepik.com/free-photo/luxurious-car-parked-highway-with-illuminated-headlight-sunset_181624-60607.jpg",
  // Add more image URLs as needed
];
// data.js
const images = [
  {
    url: "./images/Portfolio/Part1.jpg",
    category: "Our Participation",
  },
  {
    url: "./images/Portfolio/Part2.jpg",
    category: "Our Participation",
  },
  {
    url: "./images/participation/img7.JPG",
    category: "Our Participation",
  },
  {
    url: "./images/participation/img62.JPG",
    category: "Our Participation",
  },
  {
    url: "./images/Portfolio/Manu1.jpg",
    category: "Manufacturing",
  },
  {
    url: "./images/Portfolio/Manu2.jpg",
    category: "Manufacturing",
  },
  // {
  //   url: "images/car/ESVC (89).jpg",
  //   category: "Manufacturing",
  // },
  // {
  //   url: "images/car/revantacar-removebg-preview.png",
  //   category: "Manufacturing",
  // },
  // {
  //   url: "images/events/m2.jpg",
  //   category: "Manufacturing",
  // },
  // {
  //   url: "images/events/m3.jpg",
  //   category: "Manufacturing",
  // },
  {
    url: "images/events/m4.jpg",
    category: "Manufacturing",
  },
  {
    url: "images/events/m5.jpg",
    category: "Manufacturing",
  },
  // {
  //   url: "images/events/m6.jpg",
  //   category: "Manufacturing",
  // },
  {
    url: "./images/Portfolio/Events1.jpg",
    category: "Events",
  },
  {
    url: "./images/Portfolio/Events2.jpg",
    category: "Events",
  },
  // {
  //   url: "./images/Portfolio/Events3.dng",
  //   category: "Events",
  // },
  {
    url: "./images/Portfolio/Events4.jpg",
    category: "Events",
  },
  {
    url: "./images/Portfolio/Events5.jpg",
    category: "Events",
  },

  // ... other image objects with category information
];

export default images;
